@if (commercialPush) {
  <div class="alert-container dash-alert-color" [attr.data-e2e]="'e2e-push-commercial-' + commercialPush?.code">
    <p class="alert">
      @if (commercialPush.imageUrl) {
        <img
          alt=""
          class="alert-icon icon dash-image-size"
          src="{{ getImgFormat(commercialPush.imageUrl) }}"
          aria-hidden="true"
        />
      }
      <span class="ob1-alert-title dash-label-push-commercial">{{ commercialPush.content }}</span>
    </p>
    <div class="alert-content">
      <a
        ecmPushTracker
        [attr.data-e2e]="'e2e-push-commercial-btn-' + commercialPush?.code"
        [attr.id-ref-zone]="commercialPush?.idRefZone"
        [attr.abc-track-cible]="linkService.getLinkSync(commercialPush?.link)"
        [attr.abc-track-nom]="trackingName"
        [attr.abc-track-zone]="commercialPush?.trackingData?.tmsTracking?.trackingArea"
        [href]="linkService.getLinkSync(commercialPush?.link)"
        [pdb-zid]="trackingName"
        [pdb-sc]="'adv'"
        [pdb-ta]="commercialPush.advTracker"
        [pdb-idc]="commercialPush.code"
        [ecmDisabledAction]="isDisabledEclairLink"
        (click)="openLink(commercialPush); (false)"
        class="btn btn-secondary"
        type="button"
        [class.ob1-disabled]="isDisabledEclairLink"
        >{{ commercialPush.urlLabel || 'En profiter' }}</a
      >
    </div>
  </div>
}
